import type { UnlikelyVariant } from "@unlikelystudio/commerce-connector"

import { selectedOptions } from "~/lib/shopify/constants/selected-options"

type Sizes = {
  otherSizes: string[]
  standardSizes: string[]
}

// We need to add a char prefix because there are side effects
// When the filters values are numbers (we dont really know why)  - the same applies to the discount filter
export const SIZES_SEPARATOR = "__"

export function processSizes(variants: UnlikelyVariant[]) {
  return variants?.reduce<Sizes>(
    (acc, variant) => {
      const { quantityAvailable = 0 } = variant ?? {}
      const sizeOption = variant?.selectedOptions?.find(
        (option) => option?.name && selectedOptions?.size?.includes(option?.name)
      )

      if (!quantityAvailable || !sizeOption) return acc

      const size = `${SIZES_SEPARATOR}${sizeOption?.value}`

      if (!size) return acc

      if (size?.endsWith(".")) {
        return { ...acc, otherSizes: [...acc.otherSizes, size.slice(0, -1)] }
      }

      return { ...acc, standardSizes: [...acc.standardSizes, size] }
    },
    { otherSizes: [], standardSizes: [] }
  )
}
